// extracted by mini-css-extract-plugin
module.exports = {"container":"jgp-1H_L-","label":"jgp-2Sbao","icon":"jgp-3rFSc","value":"jgp-u_h-_"};